export default "__VITE_ASSET__8f863be6__"